import CandidaciesListBox from './components/CandidaciesListBox';
import PageContainer      from '@/components/pageContainer/PageContainer';
import PageTitle          from '@/components/pageTitle/PageTitle';
import { useTranslation } from 'react-i18next';

const CandidaciesPage = () => {
	const { t } = useTranslation();

	return (
		<PageContainer>
			<PageTitle>
				{t('pages.candidacies.label')}
			</PageTitle>
			<CandidaciesListBox />
		</PageContainer>
	)
}

export default CandidaciesPage;